import { ChangeEvent } from "react"
import { Block, Input, useStyletron } from "@mezo-org/mezo-clay"

import { SwappableToken } from "#/shared/types"

import SwapModalTokenSelector from "./SwapModalTokenSelector"

type SwapModalTokenInputProps = {
  value: string
  token: SwappableToken
  onInputChange: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void
  onOpenAssetSelector: () => void
  hasError: boolean
}

export default function SwapModalTokenInput({
  value,
  onInputChange,
  onOpenAssetSelector,
  token,
  hasError,
}: SwapModalTokenInputProps) {
  const [css, theme] = useStyletron()

  return (
    <Block
      className={css({
        display: "flex",
        marginTop: theme.sizing.scale300,
        marginBottom: theme.sizing.scale100,
        gap: theme.sizing.scale600,
      })}
    >
      <Input
        size="large"
        value={value}
        onChange={onInputChange}
        error={hasError}
      />
      <SwapModalTokenSelector token={token} onClick={onOpenAssetSelector} />
    </Block>
  )
}
